module.exports = __webpack_public_path__ + "assets/img/loading.38e5d7f9.gif";